import { render } from "./FilterPrice.vue?vue&type=template&id=5e0536ee"
import script from "./FilterPrice.vue?vue&type=script&lang=js"
export * from "./FilterPrice.vue?vue&type=script&lang=js"

import "./FilterPrice.vue?vue&type=style&index=0&id=5e0536ee&lang=scss"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__